import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import TherapistSidebar from "../TherapistSidebar";
import TherapistClients from "../TherapistClients";
import ClientChatHistory from "../ClientChatHistory";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import park from "../../assets/images/park.png";
import campsite from "../../assets/images/campsite.png";
import { useNavigate } from "react-router-dom";

const allowedUserIds = [
  "ZZ916584",
  "C8J1P6DR",
  "34AB56CD",
  "M2C5ZDQW",
  "ST56UV78",
  "90QR12ST",
  "34UV56WX",
  "5CAFBPYH",
  "78YZ90AB",
  "UFTBN1O1",
  "MN34OP56",
  "OP12QR34",
  "KL78MN90",
  "2D9BFUVY",
  "UV12WX34",
  "WSORODTJ",
  "OKSWae1L",
  "YB8kvHdr",
  "yDTJaiPD",
  "MJFMVAA0",
  "UFTBN1O1",
  "REj7Rzf1",
]; // Whitelisted user IDs

function TestPage() {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState("sessions");
  const [selectedClient, setSelectedClient] = useState(null);
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    setCurrentFormType,
    loading, // ✅ new
    userType,
  } = useContext(AuthContext);

  useEffect(() => {
    if (loading) return; // ✅ Wait until context is fully loaded

    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");

    if (!allowedUserIds.includes(userId)) {
      console.warn("TestPage.js: warn event");
      navigate("/therapy-rooms");
    }
  }, [loading, PlutonicuserID, navigate]);

  useEffect(() => {
    const updateSidebarForScreen = () => {
      if (typeof window !== "undefined") {
        setSidebarCollapsed(window.innerWidth < 1024);
      }
    };
    if (userType === "Client") setSidebarCollapsed(true);
    updateSidebarForScreen();
    window.addEventListener("resize", updateSidebarForScreen);
    return () => window.removeEventListener("resize", updateSidebarForScreen);
  }, []);

  // if (loading) {
  //   // ✅ Optionally show loader to avoid flicker
  //   return (
  //     <div
  //       style={{
  //         height: "100vh",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //       }}
  //     >
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  const rooms = [
    {
      id: "test-park-therapy",
      title: "Test Park Therapy Room",
      description: "Testing room for the park.",
      image: park,
      style: "Green Space",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-beach-therapy",
      title: "Test Beach Therapy Room",
      description: "Testing room for the beach.",
      image: beach,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-forest-therapy",
      title: "Test forest Therapy Room",
      description: "Testing room for the forest.",
      image: forest,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-campsite-therapy",
      title: "Test campsite Therapy Room",
      description: "Testing room for the campsite.",
      image: campsite,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
  ];

  const handleViewClientHistory = (client) => {
    setSelectedClient(client);
  };

  const handleBackToClients = () => {
    setSelectedClient(null);
  };

  const handleEnterClick = (roomType) => {
    const userId = PlutonicuserID;
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }

    const testMeetingID = `${roomType}-fixed-meeting-id`;
    sessionStorage.setItem("meetingID", testMeetingID);
    sessionStorage.setItem("userId", userId);

    const realRoomType = roomType.replace("test-", "");
    navigate(`/unity-room/${realRoomType}`);
  };

  return (
    <div>
      <Navbar />
      {userType === "Therapist" && (
        <TherapistSidebar
          activeNavItem={activeNavItem}
          setActiveNavItem={setActiveNavItem}
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />
      )}
      {activeNavItem === "sessions" ? (
        <div
          className={`flex flex-col items-center min-h-screen pt-24 pb-16 px-12 transition-all duration-300 ${
            userType !== "Therapist" ? "" : sidebarCollapsed ? "ml-16" : "ml-64"
          }`}
          style={{
            background:
              "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
          }}
        >
          <div className="w-full max-w-7xl">
            <h2 className="text-3xl font-bold mb-12 pl-4 mt-8">
              Test Virtual Spaces
            </h2>

            <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
              {rooms.map((room) => (
                <TherapyRoomCard
                  key={room.id}
                  room={{
                    id: room.id,
                    image: room.image,
                    title: room.title,
                    style: room.style,
                    description: room.description,
                    accessibility: room.accessibility,
                    available: room.available,
                    sessionStartTimeEST: room.sessionStartTimeEST,
                    online: room.online,
                  }}
                  onEnterClick={() => handleEnterClick(room.id)}
                  sessions={[
                    {
                      meetingID: `${room.id}-fixed-id`,
                      sessionStartTimeEST: "Always Available",
                      isAvailable: true,
                      isUpcoming: false,
                      isPrimary: true,
                      sessionStartTimeUTC: new Date().toISOString(),
                    },
                  ]}
                />
              ))}
            </div>
          </div>
        </div>
      ) : selectedClient ? (
        <div
          className={`transition-all duration-300 ${
            sidebarCollapsed ? "ml-16" : "ml-64"
          }`}
        >
          <ClientChatHistory
            clientName={selectedClient.name}
            onBack={handleBackToClients}
          />
        </div>
      ) : (
        <div
          className={`min-h-screen pt-24 pb-16 transition-all duration-300 bg-white ${
            sidebarCollapsed ? "ml-16" : "ml-64"
          }`}
        >
          <div className="w-full mx-auto px-12">
            <TherapistClients onViewHistory={handleViewClientHistory} />
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default TestPage;
